exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".range-product .ratio-img[data-v-f6c667b4]{background:#f5f5f5}.range-product .range[data-v-f6c667b4]{font-size:1.1875rem}.range-product .price[data-v-f6c667b4],.range-product .product[data-v-f6c667b4]{font-size:1rem}", ""]);

